import { render, staticRenderFns } from "./requestTat.vue?vue&type=template&id=7bc87093&scoped=true"
import script from "./requestTat.vue?vue&type=script&lang=js"
export * from "./requestTat.vue?vue&type=script&lang=js"
import style0 from "./requestTat.vue?vue&type=style&index=0&id=7bc87093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc87093",
  null
  
)

export default component.exports